export { Paper } from '@mantine/core'
